module.exports = __webpack_public_path__ + "p7_img2.jpg?6527fcf0b145d18df3f61dd0b8065204";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img2.jpg
// module id = 130
// module chunks = 0